import React, { memo } from 'react'
import tw from 'twin.macro'
import { RefreshMinor } from '@shopify/polaris-icons'
import { Button } from 'src/components/shared/Button'
import { TableSearch } from 'src/components/shared/table/TableSearch'

/** Filtering is in-memory here, so the search does not need dashboard's 700ms API debounce. */
const SEARCH_DEBOUNCE_MS = 200

/** Lines the search field up with the 36px header buttons. */
const HEADER_CONTROL_HEIGHT = 36

/** Matches the hairline treatment CustomersTableToolbar applies to its white buttons. */
const headerButtonCss = tw`border border-solid border-shades-100 hover:border-shades-200 active:border-shades-200`

interface Props {
  searchQuery: string
  onSearchChange(value: string): void
  onRefresh(): void
}

const OnboardingTemplatesTableToolbarComponent = ({
  searchQuery,
  onSearchChange,
  onRefresh,
}: Props) => {
  return (
    <div
      css={tw`flex flex-row items-center gap-4 rounded-t-lg border-0 border-b border-t border-solid border-shades-100 bg-white px-4 py-3`}
    >
      <TableSearch
        searchQuery={searchQuery}
        onChangeSearchQuery={onSearchChange}
        height={HEADER_CONTROL_HEIGHT}
        debounceMs={SEARCH_DEBOUNCE_MS}
        inputDataTestId="onboarding-templates-list-search-input"
        clearButtonDataTestId="onboarding-templates-list-search-clear-btn"
      />
      {/* Refresh is an action rather than a filter, so it sits at the far end. */}
      <div css={tw`ml-auto`}>
        <Button
          size="small"
          color="white"
          className={headerButtonCss}
          leftIcon={<RefreshMinor width={20} />}
          onClick={onRefresh}
          data-testid="onboarding-templates-list-refresh-button"
        >
          Refresh
        </Button>
      </div>
    </div>
  )
}

export const OnboardingTemplatesTableToolbar = memo(OnboardingTemplatesTableToolbarComponent)
